import { ShiftDirectionEnum } from '../../../../common/enum/shift-direction.enum';
import { InternalServerErrorException } from '../../../../common/exceptions/exceptions';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import {
  getPeriodBoundariesFromStartDateAndGranularity,
  shiftDateToNearestGranularity,
} from '../../../../common/utils/datetime.util';
import { MetricValueType } from '../../../../interface/dtos';
import { GetChallengeInsightProgressSummaryRequestDto } from '../../../../interface/dtos/challenge-insights/get-challenge-insight-progress-summary.request.dto';
import { ChallengeInsightProgressDigitalWorkingHoursSummaryAggregateRoot } from '../../../domain/aggregates/challenge-insights/challenge-insight-progress-digital-working-hours.aggregate-root';
import { GetChallengeInsightProgressDigitalWorkingHoursSummaryDomainService } from '../../../domain/services/challenge-insights/get-challenge-insight-progress-digital-working-hours-summary.domain-service';
import { OrganizationWorkingSessionsPort } from '../../ports/working-sessions/organization-working-sessions.port';

export class GetChallengeInsightProgressDigitalWorkingHoursSummaryApplicationService {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly port: OrganizationWorkingSessionsPort,
    protected readonly domainService: GetChallengeInsightProgressDigitalWorkingHoursSummaryDomainService
  ) {}

  async execute(
    props: GetChallengeInsightProgressSummaryRequestDto
  ): Promise<ChallengeInsightProgressDigitalWorkingHoursSummaryAggregateRoot> {
    try {
      this.logManager.debug(
        'Called GetChallengeInsightProgressDigitalWorkingHoursSummaryApplicationService'
      );
      const shiftedEndDate = shiftDateToNearestGranularity({
        date: new Date(props.params.endDate),
        granularity: props.params.granularity,
        direction: ShiftDirectionEnum.Left,
      });
      const [entities, todayEntities] = await Promise.all([
        this.port.queryDigitalWorkingHoursByDateRange({
          granularity: props.params.granularity,
          userIds: props.params.userIds,
          startDate: props.params.startDate,
          endDate: props.params.endDate,
          segments: props.params.segments ?? undefined,
          departmentId: props.params.departmentId ?? undefined,
          token: props.config.token,
        }),
        this.port.queryDigitalWorkingHoursByDateRange({
          granularity: props.params.granularity,
          userIds: props.params.userIds,
          startDate: shiftedEndDate.toISOString().split('T')[0],
          endDate: props.params.endDate,
          token: props.config.token,
          departmentId: props.params.departmentId ?? undefined,
        }),
      ]);

      return await this.domainService.execute({
        entities,
        systemDayEntities: todayEntities,
        type: MetricValueType.Duration,
        targetValue: props.params.challengeTargetValue,
      });
    } catch (error) {
      this.logManager.error(error);
      throw new InternalServerErrorException(error);
    }
  }
}
